import first from 'lodash/first'
import keys from 'lodash/keys'

class FlyFilterSelectionHistoryStorage {
  constructor() {
    this.allFilters = []
    this.currentFilter = {}
  }

  getAllFilters() {
    return this.allFilters
  }

  setCurrentFilterChange(filter) {
    this.currentFilter = filter
  }

  getCurrentFilterChange() {
    return this.currentFilter
  }

  removePreviousFilter(filter, isSliceFilter) {
    if (isSliceFilter) {
      this.allFilters = this.allFilters.filter((filterItem) => {
        return !(
          first(keys(filterItem)) === first(keys(filter)) &&
          filterItem.sliceFilter.sliceId === filter.sliceFilter.sliceId &&
          filterItem.sliceFilter.sliceKey === filter.sliceFilter.sliceKey
        )
      })
    } else {
      this.allFilters = this.allFilters.filter((filterItem) => {
        return first(keys(filterItem)) !== first(keys(filter))
      })
    }
  }

  save(filterInfo, isCurrent) {
    const isSliceFilter = !!filterInfo.sliceFilter
    const isDeselectedSliceFilter = isSliceFilter && !filterInfo.selected
    const filter = isSliceFilter ? { sliceFilter: filterInfo.sliceFilter } : filterInfo
    const filterName = first(keys(filter))
    const existFiltersCount = this.allFilters.filter((filterItem) => {
      return first(keys(filterItem)) === first(keys(filter))
    }).length

    if (isSliceFilter && isDeselectedSliceFilter) {
      this.removePreviousFilter(filter, true)
      return false
    } else if (
      filter[filterName] === '' ||
      filter[filterName].length === 0 ||
      (filter.numOfStops && filter.numOfStops === 7) ||
      existFiltersCount
    ) {
      this.removePreviousFilter(filter)
    } else {
      this.allFilters.push(filter)
    }

    if (isCurrent) {
      this.setCurrentFilterChange(filter)
    }

    return true
  }
}

const flyFilterSelectionHistoryStorage = new FlyFilterSelectionHistoryStorage()

export { flyFilterSelectionHistoryStorage }
